import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Table, TableHead, TableCell, TableBody, TableRow, Button, Typography, Grid } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete';
import Loading from '../components/Loading';
import APIService from '../services/APIService';
import PaddedGrid from '../components/PaddedGrid';
import MenuItemAdder from '../components/MenuItemAdder';
import RestaurantType, { ALACARTE } from '../constants/RestaurantType';
import MenuImporter from '../components/MenuImporter';
import AppContext from '../AppContext';
import FormatDate from '../FormatDate';
import { withTranslation } from 'react-i18next';

class Menu extends Component {
    constructor(props) {
        super(props);

        this.restaurantId = props.match.params.restaurantId;
        this.menuId = props.match.params.menuId;

        this.state = {
            loading: true,
            redirect: false,
            open: false,
        };

        this.handleItemAdd = this.handleItemAdd.bind(this);
    }

    handleItemAdd(items) {
        let { menu } = this.state;

        items = Array.isArray(items) ? items : [items];
        items.forEach((item) => menu.items.push(item));

        this.setState({menu, open: false});
    }

    deleteItem(index) {
        let { menu } = this.state;
        const item = menu.items.splice(index, 1)[0];

        APIService.destroyMenuItem(this.restaurantId, this.menuId, item.id);
        this.setState({menu});
    }

    destroy() {
        APIService.destroyMenu(this.restaurantId, this.menuId)
            .then(() => {
                AppContext.toast(this.props.t('Menu poistettiin onnistuneesti'));
                this.setState({redirect: true});
            }).catch((e) => {
                AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e);
            });
    }

    componentDidMount() {
        APIService.getMenu(this.restaurantId, this.menuId)
            .then((menu) => {
                this.setState({menu});

                return APIService.getFoodTypes();
            }).then((types) => {
                const mappedTypes = types.reduce((acc, type) => {
                    acc[type.id] = type.name;
                    return acc;
                }, {});

                const mappedTypesEN = types.reduce((acc, type) => {
                    acc[type.id] = type.name_en || type.name;
                    return acc;
                }, {});

                this.setState({
                    types: {
                        fi: mappedTypes,
                        en: mappedTypesEN
                    },
                    loading: false});
            }).catch((e) => {
                AppContext.toast(`${this.props.t('Tapahtui odottamaton virhe')}, ` + e);
            });
    }

    render() {
        if (this.state.loading) {
            return <Loading/>;
        }

        if (this.state.redirect) {
            return <Redirect to={`/restaurants/${this.restaurantId}`}/>;
        }

        const { menu, types } = this.state;

        return (
            <PaddedGrid>
                <Grid item xs={12}>
                    <Button component={Link} to={`/restaurants/${this.restaurantId}`}>{this.props.t('Takaisin')}</Button>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="headline">{this.props.t(RestaurantType[menu.type])} Menu | {FormatDate(menu.date_from)} - {FormatDate(menu.date_to)}</Typography>
                </Grid>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{this.props.t('Nimi')}</TableCell>
                            <TableCell>{this.props.t('Laji')}</TableCell>
                            {menu.type == ALACARTE && <TableCell>{this.props.t('Paino')}</TableCell>}
                            <TableCell>{this.props.t('Hinta')}</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {menu.items.map((item, i) => {
                            return (
                                <TableRow key={item.id}>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>{types[this.props.i18n.language][item.food_type_id]}</TableCell>
                                    {menu.type == ALACARTE && <TableCell>{item.weight} kg</TableCell>}
                                    <TableCell>{item.price ? `${item.price} €/kg` : ''}</TableCell>
                                    <TableCell>
                                        <Delete
                                            onClick={() => AppContext.prompt(() => this.deleteItem(i))}/>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>

                <MenuItemAdder
                    open={this.state.open}
                    restaurantId={this.restaurantId}
                    menuId={this.menuId}
                    itemType={this.state.menu.type}
                    onAddedItem={this.handleItemAdd}
                    onClose={() => this.setState({open: false})}
                />

                <Button
                    color="primary"
                    onClick={() => this.setState({open: true})}
                >+ {this.props.t('Lisää uusi ruokalaji')}</Button>

                <Button
                    color="secondary"
                    onClick={() => AppContext.prompt(() => this.destroy())}
                >{this.props.t('Poista menu')}</Button>
            </PaddedGrid>
        );
    }
}

export default withTranslation()(Menu);



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Menu.js